<template>
    <div class="FNews">
        <el-drawer
                class="drawer_news"
                title="我的消息"
                :with-header="false"
                :visible.sync="$store.state.news.show"
                direction="rtl"
                close-on-press-escape>
            <div class="title">我的消息</div>
            <el-scrollbar ref="scrollbar"
                          :native="false"
            >
                <div :class="{unreadRead:item.unreadRead === '0'}" v-for="(item,index) in newslist" @click="changeRead(item.id)">
                    <div class="headline">来自{{item.company}} 的消息</div>
                    <div class="subtitle">{{item.userName}}邀请您共同参与中心管控<el-link type="primary" @click="jumpSetContents(item.storyBoardID)">点击预览</el-link></div>
                    <div class="createTime">{{item.createTime}}</div>
                    <FSvg class="delete" color="#999" title="圆叉删除" @click.stop.native="deleteNews(item.id)"></FSvg>
                </div>
            </el-scrollbar>
        </el-drawer>
        <div v-if="preview" class="preview">
            <FSvg class="preview_svg" color="#999" IconSize="40" title="圆叉删除" font @click.native="preview = false,cancelSignalR()"></FSvg>
            <FUrlBtn class="preview_btn" title="进入编辑页面" @click.native="preview = false"  :IconSize="20" :path="`/setContents?id=${previewId}`"></FUrlBtn>
            <FTeamSharePreview  :id="previewId"></FTeamSharePreview>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/7 2:40 下午
     */
    import config from '@/assets/js/config'
    import {
        //修改已读状态
        setTeamSharingNewsListRead,
        //删除中心管控内容详情
        deleteTeamSharingNews

    } from '@/assets/axios/rearMain'

    export default {
        name: 'FBtn',
        components: {},
        props: {
            //消息列表
            newslist: {
                type: Array,
                default: false
            },
        },
        data() {
            return {
                //预览弹框
                preview:false,
                //预览故事版id
                previewId:''
            }
        },
        methods: {
            //消息未读变已读
            changeRead(id) {
                this.newslist.map((value, index, array)=>{
                   if(value.id === id){
                       if(value.unreadRead === "0"){
                           setTeamSharingNewsListRead({teamSharingID:id}).then(res=>{
                               if(res.code === 200){
                                   value.unreadRead = '1'
                               }
                           })
                       }
                   }
               })
            },
            //删除
            deleteNews(id){
                this.$alert('删除后无法恢复，还要继续删除吗？', '删除共享组', {
                    confirmButtonText: '确定',
                    callback: action => {
                        deleteTeamSharingNews({id:id}).then(res=>{
                            if(res.code === 200){
                                this.newslist.map((value, index, array)=>{
                                    if(value.id === id){
                                        this.newslist.splice(index,1)
                                    }
                                })
                            }
                        })
                    }
                });
            },
            //打开预览
            jumpSetContents(id){
                this.previewId = id;
                this.preview = true;
                this.$store.dispatch('setNewsShow')
                // this.$router.push({
                //     path:'setContents',
                //     query:{id:id}
                // })
                // connection.start().then(() => {
                //     console.log('成功');
                // }).catch(() => {
                //     console.log('失败');
                // });

            },
            //取消链接signalR
            cancelSignalR(){
                location.reload()
                // this.signalr.start().then(() => {
                //     this.signalr.invoke('OnDisconnectedAsync', null);
                // });
                // this.signalGraf.start().then(() => {
                //     this.signalGraf.invoke('OnDisconnectedAsync', null);
                // })
            },
        },
        mounted() {
        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .FNews {
        > div {
            > div {
                > section {
                    background: #eee;
                    height: 100%;

                    .title {
                        line-height: 50px;
                        font-size: 20px;
                        padding-left: 20px;
                        font-weight: bold;
                    }

                    > div {
                        > div {
                            > div {
                                padding: 20px;
                                height: 100%;
                                width: 100%;

                                > div {
                                    background: #fff;
                                    border-radius: 5px;
                                    width: 100%;
                                    height: calc(100% / 5);
                                    box-shadow: 0 0 5px #999;
                                    padding: 0 10px;
                                    position: relative;
                                    color: #aaa;
                                    margin-bottom: 20px;

                                    .headline {
                                        font-size: 20px;
                                        font-weight: 600;
                                        line-height: 37px;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                    }

                                    .subtitle {
                                        text-indent: 2rem;
                                        height: 95px;
                                        overflow: hidden;
                                        line-height: 23px;
                                        text-overflow: ellipsis;
                                        display: -webkit-box;
                                        -webkit-box-orient: vertical;
                                        -webkit-line-clamp: 4;
                                    }

                                    .createTime {
                                        position: absolute;
                                        right: 10px;
                                        bottom: 10px;
                                    }

                                    .delete {
                                        position: absolute;
                                        left: 10px;
                                        bottom: 10px;
                                    }
                                }

                                .unreadRead {
                                    color: #232323;
                                }
                            }
                        }
                    }

                    .el-scrollbar {
                        width: 100%;
                        height: calc(100% - 50px);

                        .el-scrollbar__wrap {
                            overflow-x: hidden;
                        }

                        .el-scrollbar__view {
                            > div {
                                position: relative;
                                transform-origin: 0 0;
                            }
                        }
                    }


                }
            }
        }
    }
</style>
